import React from "react";
import { ToastContainer } from "react-toastify";
import Header from "./Header";
import Footer from "./Footer";
import { Outlet } from "react-router-dom";

const MainLayout = () => {
  return (
    <div className="main">
      <Header />
      <Outlet />

      {/* <a
        href="https://wa.me/919022218277"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img src="/whatsapp.png" alt="WhatsApp" />
      </a> */}
      <Footer />
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default MainLayout;
